import { GearSix, SealCheck, UserGear } from '@phosphor-icons/react'
import { useId } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { kuniriIconWeight } from '@/lib/icons'
import { SettingsBackLink } from '../components/settings-back-link'

/**
 * D-099: the profile page stays a read-only card; every configuration lives
 * under the settings menu so the release can grow it (theme, biometric, …)
 * without re-crowding the profile.
 *
 * The notification destination deep-links into the feeds screen *with its
 * settings drawer open*, which the maintainer asked for explicitly.
 */
export function SettingsScreen() {
  const { t } = useTranslation()
  const headingId = useId()

  return (
    <section
      aria-labelledby={headingId}
      className="content-width min-h-dvh pb-10 pt-[var(--safe-top)]"
    >
      <div className="mx-auto w-full max-w-[640px] px-0.5 md:px-0">
        <div className="flex items-center gap-2 py-3">
          <SettingsBackLink to="/profile" />
          <h1 id={headingId} className="text-[28px] leading-tight font-bold">
          {t('screens.settings.title')}
        </h1>
        </div>
        <p className="mt-1 text-sm leading-relaxed text-muted">
          {t('screens.settings.subtitle')}
        </p>

        <div className="mt-5 space-y-2">
          <Link
            to="/notifications?settings=1"
            state={{ from: 'settings' }}
            className="flex min-h-13 items-center gap-3 rounded-[18px] border border-line bg-white px-4 py-3 hover:bg-mint"
          >
            <span
              className="grid size-10 shrink-0 place-items-center rounded-[13px] bg-mint text-teal"
              aria-hidden="true"
            >
              <GearSix size={19} weight={kuniriIconWeight} />
            </span>
            <span className="min-w-0">
              <span className="block font-bold text-deep">
                {t('screens.settings.notifications.title')}
              </span>
              <span className="block text-sm text-muted">
                {t('screens.settings.notifications.body')}
              </span>
            </span>
          </Link>

          <Link
            to="/settings/account"
            className="flex min-h-13 items-center gap-3 rounded-[18px] border border-line bg-white px-4 py-3 hover:bg-mint"
          >
            <span
              className="grid size-10 shrink-0 place-items-center rounded-[13px] bg-mint text-teal"
              aria-hidden="true"
            >
              <UserGear size={19} weight={kuniriIconWeight} />
            </span>
            <span className="min-w-0">
              <span className="block font-bold text-deep">
                {t('screens.settings.account')}
              </span>
              <span className="block text-sm text-muted">
                {t('screens.settings.accountBody')}
              </span>
            </span>
          </Link>

          <Link
            to="/settings/app"
            className="flex min-h-13 items-center gap-3 rounded-[18px] border border-line bg-white px-4 py-3 hover:bg-mint"
          >
            <span
              className="grid size-10 shrink-0 place-items-center rounded-[13px] bg-mint text-teal"
              aria-hidden="true"
            >
              <SealCheck size={19} weight={kuniriIconWeight} />
            </span>
            <span className="min-w-0">
              <span className="block font-bold text-deep">
                {t('screens.settings.app')}
              </span>
              <span className="block text-sm text-muted">
                {t('screens.settings.appBody')}
              </span>
            </span>
          </Link>
        </div>
      </div>
    </section>
  )
}
